import type { Section } from '@common/formEngine/formEngine.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';

export type NoteData = {
    assets: ProcessActivityAsset[];
    note: string | null;
    title: string | null;
};

export const noteSections: Section<NoteData>[] = [
    {
        fields: [
            {
                isRequired: true,
                key: 'title',
                label: 'Titel',
                type: 'textInput',
            },
            {
                isRequired: true,
                key: 'note',
                label: 'Notitie',
                type: 'textArea',
            },
            {
                key: 'assets',
                label: 'Bijlage(n)',
                type: 'assets',
            },
        ],
    },
];
